import * as React from 'react'
import { CallRegular } from '@fluentui/react-icons'
import { Button, ButtonProps, Tooltip } from '@fluentui/react-components'

type PhoneNumberButtonProps = {
    clickValue: string
    textValue?: string
    withTooltip?: boolean
    tooltipValue?: string
    buttonProps?: ButtonProps
}

export default function PhoneNumberButton(props: PhoneNumberButtonProps) {
    const button = (
        <Button
            size="small"
            appearance={'subtle'}
            icon={<CallRegular />}
            {...props.buttonProps}
            onClick={e => {
                e.stopPropagation()
                window.open(`tel:${props.clickValue}`)
            }}
        >
            {props.textValue}
        </Button>
    )

    if (props.withTooltip) {
        return (
            <Tooltip relationship={'description'} content={props.tooltipValue ?? props.textValue ?? props.clickValue} withArrow>
                {button}
            </Tooltip>
        )
    }

    return button
}
